module.exports = __webpack_public_path__ + "img/1fie-h-le'ej.9ef7ef67.png";